module.exports = __webpack_public_path__ + "img/101.1962fde7.jpg";